var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge"},[_c('Vector',{staticClass:"badge-icon",attrs:{"src":_vm.img}}),_vm._v(" "),_c('div',{staticClass:"badge-text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e31aa208","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/abstract/Badge.vue
// module id = null
// module chunks = 